import './front.scss';
import { AssetsGridFront } from './AssetsGridFront.js';

new AssetsGridFront( document ).init();
